import "react";

import type { StyledComponent } from "@emotion/styled";
import { Check } from "@mui/icons-material";
import {
  Grid,
  type GridProps,
  StepLabel as MuiStepLabel,
  StepConnector,
  type SvgIconProps,
} from "@mui/material";
import { styled } from "@mui/material/styles";

const PREFIX = "stepper";

export const classes = {
  active: `${PREFIX}-active`,
};

export const StepperConnector = styled(StepConnector)(({ theme }) => ({
  "& .MuiStepConnector-alternativeLabel": {
    top: 10,
    left: "calc(-50% + 16px)",
    right: "calc(50% + 16px)",
  },
  "&.Mui-active, &.Mui-completed": {
    "& .MuiStepConnector-line": {
      borderColor: theme?.palette?.primary?.main,
    },
  },
  "& .MuiStepConnector-line": {
    borderColor: "#eaeaf0",
    borderTopWidth: 3,
    borderRadius: 1,
  },
}));

export const IconWrapper: StyledComponent<GridProps> = styled(Grid)(() => ({
  color: "#eaeaf0",
  display: "flex",
  height: 27,
  alignItems: "center",
}));

export const WhiteCheckIcon: StyledComponent<SvgIconProps> = styled(Check)(() => ({
  color: "white",
  fontSize: 18,
}));

export const CheckIcon: StyledComponent<SvgIconProps> = styled(Check)(({ theme }) => ({
  color: theme?.palette?.primary?.main,
  zIndex: 1,
  fontSize: 18,
}));

interface ICircleProps {
  active: boolean;
}

export const Circle = styled("div", {
  shouldForwardProp: (prop) => prop !== "active",
})<ICircleProps>(({ active, theme }) => ({
  width: 8,
  height: 8,
  borderRadius: "50%",
  backgroundColor: active ? theme?.palette?.primary?.main : "currentColor",
}));

export const StepLabel = styled(MuiStepLabel)(({ theme }) => ({
  "& .MuiStepLabel-label, & .MuiStepLabel-alternativeLabel, & .MuiStepLabel-completed": {
    ...theme?.typography?.body1,
  },
  "& .MuiStepLabel-label": {
    color: theme?.palette?.text?.primary,
  },
  "& .Mui-active": {
    color: `${theme?.palette?.primary?.main} !important`,
    fontWeight: "600 !important",
    fontSize: "15px",
  },
}));
